import { Text } from 'components/mvp-typography';
import React, { CSSProperties } from 'react';
import { grey } from 'styles/colors';

interface ChatMessageProps {
  content: string;
  icon?: React.ReactNode;
  noBackground?: boolean;
  /**
   * The color of the text
   */
  color?: string;
  style?: CSSProperties;
}

/**
 * Display of a single chat message
 * @param props
 * @returns
 */
export function ChatMessage(props: ChatMessageProps) {
  return (
    <div
      style={{
        background: props.noBackground ? 'none' : grey['light'],
        color: props.color ?? grey['medium'],
        borderRadius: 10,
        padding: '0.6rem 0.9rem',
        whiteSpace: 'preserve',
        ...props.style
      }}
    >
      <Text>{props.content}</Text>
    </div>
  );
}
